(() => {
  const main = qs('#js-main');
  const stickyHeader = qs('.js-header-sticky');
  const headerContainer = stickyHeader.parentElement.offsetTop;
  const headerFixed = 'header--fixed';
  const headerSearch = qs('.js-header__search');
  const headerSearchLower = qs('.js-header__search--lower-pages');
  const headerSearchBtn = qs('.js-header__search-button');
  const headerSearchHidden = 'header__search--hidden';
  const breakpoint = window.matchMedia('(max-width: 989px)');
  const headerSearchPredictive = qs('.js-header__search-predictive');
  const headerSearchInput = qs('.js-header__search-input');

  if(stickyHeader) {
    const bottomValue = stickyHeader.getBoundingClientRect().top + stickyHeader.clientHeight;
    stickyHeader.style.setProperty('--burger-menu-top', `${bottomValue}px`);
    document.body.style.setProperty('--header-height', `${bottomValue}px`);

    if(breakpoint.matches) {
      headerSearchLower && headerSearchLower.classList.add(headerSearchHidden);
    }

    window.addEventListener('scroll', () => {
      const top = document.documentElement.style.getPropertyValue('top');
      const topValue = top ? Number(top.replace('px', '').replace('-', '')) : 0;

      if(window.scrollY > headerContainer &&
        document.body.clientHeight > window.innerHeight) {
        stickyHeader.classList.add(headerFixed);
        main.style.marginTop = `${stickyHeader.getBoundingClientRect().height}px`;  
        main.style.setProperty(`--timeline-menu-top`, `${stickyHeader.getBoundingClientRect().height}px`); 
        stickyHeader.style.setProperty('--burger-menu-top', `${stickyHeader.getBoundingClientRect().height}px`);
        document.body.style.setProperty('--header-height', `${stickyHeader.getBoundingClientRect().height}px`);
        if(breakpoint.matches  && headerSearchInput != document.activeElement) {
          headerSearch && headerSearch.classList.add(headerSearchHidden);
        }
      } else if(topValue > headerContainer) {
        stickyHeader.style.top = 0; 
      } else {
        stickyHeader.classList.remove(headerFixed);
        main.style.marginTop = '';
        main.style.setProperty(`--timeline-menu-top`, 0); 
        stickyHeader.style.setProperty('--burger-menu-top', `${bottomValue}px`);
        document.body.style.setProperty('--header-height', `${bottomValue}px`);
      }
    })
  }

  if(headerSearchBtn && breakpoint.matches) {
    headerSearchBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if(getComputedStyle(headerSearch).visibility === 'hidden') {
        headerSearch.classList.remove(headerSearchHidden);
      } else if(headerSearchInput != document.activeElement) {
        headerSearch.classList.add(headerSearchHidden);
      }
    })
  }

  window.addEventListener('click', (e) => {
    if(!getClosest('.js-header__search', e.target) && headerSearchInput != document.activeElement) {
      headerSearchPredictive.style.display = 'none';
    }
  });

  new Selector({ id: '#language-selector', onChange: (e) => console.log(e) });
  new Selector({ id: '#country-selector', onChange: (e) => console.log(e) });
  new Selector({ id: '#currency-selector', onChange: (e) => console.log(e) });
})();
